import {
  BookingStatusEnum,
  AgencyInvoiceStatusEnum,
  ExternalBookingStatusEnum,
} from '@/api/types';
import { search_invoices } from '@/api/invoice';

export const bookingStatusToInvoiceStatus = (status: BookingStatusEnum) =>
  (status as BookingStatusEnum) === BookingStatusEnum.SUBMITTED
    ? search_invoices.InvoiceStatusEnum.GENERATED
    : (status as BookingStatusEnum) === BookingStatusEnum.CONFIRMED_INIT
    ? search_invoices.InvoiceStatusEnum.CONFIRMED_INIT
    : (status as BookingStatusEnum) === BookingStatusEnum.CONFIRMED_SUP
    ? search_invoices.InvoiceStatusEnum.CONFIRMED_SUP
    : (status as BookingStatusEnum) === BookingStatusEnum.CONFIRMED
    ? search_invoices.InvoiceStatusEnum.CONFIRMED
    : (status as BookingStatusEnum) === BookingStatusEnum.PAYMENT_NOTIFIED
    ? search_invoices.InvoiceStatusEnum.CONFIRMED
    : (status as BookingStatusEnum) === BookingStatusEnum.PAYMENT_CONFIRMED
    ? search_invoices.InvoiceStatusEnum.PAYMENT_CONFIRMED
    : (status as BookingStatusEnum) === BookingStatusEnum.DELIVERY_PREPARING
    ? search_invoices.InvoiceStatusEnum.PAYMENT_CONFIRMED
    : (status as BookingStatusEnum) === BookingStatusEnum.DELIVERY_STARTED
    ? search_invoices.InvoiceStatusEnum.PAYMENT_CONFIRMED
    : (status as BookingStatusEnum) === BookingStatusEnum.DELIVERY_FINISHED
    ? search_invoices.InvoiceStatusEnum.PAYMENT_CONFIRMED
    : (status as BookingStatusEnum) ===
      BookingStatusEnum.DELIVERY_FINISHED_ETPENDING
    ? search_invoices.InvoiceStatusEnum.PAYMENT_CONFIRMED
    : search_invoices.InvoiceStatusEnum.UNKNOWN_STATUS;

export const agencyInvoiceStatusToInvoiceStatus = (
  status: AgencyInvoiceStatusEnum
) =>
  (status as AgencyInvoiceStatusEnum) ===
  AgencyInvoiceStatusEnum.INVOICE_GENERATED
    ? search_invoices.InvoiceStatusEnum.GENERATED
    : (status as AgencyInvoiceStatusEnum) ===
      AgencyInvoiceStatusEnum.INVOICE_CONFIRMED_INIT
    ? search_invoices.InvoiceStatusEnum.CONFIRMED_INIT
    : (status as AgencyInvoiceStatusEnum) ===
      AgencyInvoiceStatusEnum.INVOICE_CONFIRMED_SUP
    ? search_invoices.InvoiceStatusEnum.CONFIRMED_SUP
    : (status as AgencyInvoiceStatusEnum) ===
      AgencyInvoiceStatusEnum.INVOICE_CONFIRMED
    ? search_invoices.InvoiceStatusEnum.CONFIRMED
    : (status as AgencyInvoiceStatusEnum) ===
      AgencyInvoiceStatusEnum.INVOICE_PAYMENT_CONFIRMED
    ? search_invoices.InvoiceStatusEnum.PAYMENT_CONFIRMED
    : search_invoices.InvoiceStatusEnum.UNKNOWN_STATUS;
